import React, { useState } from 'react';
import Card from 'components/card';
import InputField from 'components/fields/InputField';
import { FaArrowLeftLong } from "react-icons/fa6";
import { forgetPassword } from '../../services/ApiLogin';

const ForgetPassword = ({ setForgetPassword }) => {
    const [formData, setFormData] = useState({
        email: '',
        newPassword: '',
    });

    const handleChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
    };

    const handleChangePassword = async () => {
        if (!formData.email) {
            alert("Please enter your email.");
            return;
        }

        if (!formData.newPassword) {
            alert("Please enter a new password.");
            return;
        }
        try {
            await forgetPassword("auth/forgetPassword", formData);
            alert("Password updated successfully!");
            setFormData({ email: '', newPassword: '' });
            setForgetPassword(false);
        } catch (err) {
            alert("Error: " + err.message);
        }
    };

    return (
        <Card className="w-full h-full bg-white p-4 rounded-xl">
            <div className="flex items-center mb-3">
                <div onClick={() => setForgetPassword(false) } className="mr-3 cursor-pointer"><FaArrowLeftLong /></div>
                <div className="text-xl font-bold text-navy-700 dark:text-white">Reset Password</div>
            </div>
            <InputField
                variant="auth"
                extra="mb-3"
                label="Email*"
                placeholder="user@mail.com"
                id="email"
                type="text"
                autoComplete="email"
                value={formData.email}
                onChange={(e) => handleChange("email", e.target.value)}
            />
            <InputField
                variant="auth"
                extra="mb-3 w-[100%]"
                label="Change Password*"
                placeholder="Enter Your New Password"
                id="newPassword"
                type="password"
                autoComplete="off"
                value={formData.newPassword}
                onChange={(e) => handleChange("newPassword", e.target.value)}
            />
            <button
                onClick={handleChangePassword}
                className="mt-4 w-full py-2 bg-brand-500 text-white rounded-md hover:bg-brand-700"
            >
                Reset Password
            </button>
        </Card>
    );
};

export default ForgetPassword;
